import React from "react";

export default function GenericDropdown(props) {
  const {
    title,
    inputName,
    inputValue,
    listItemArray=[],
    changeCallback,
    errorMessage,
    errorMessageStyle,
    styles={},
    disabled,
  } = props;

  function generateOptions() {
    return listItemArray.map((item) => {
      return (
        <option key={"dropdown_option_" + item} value={item}>
          {item}
        </option>
      );
    });
  }

  function handleOnChange(event) {
    const { value } = event.target;
    changeCallback(inputName, value);
  }

  return (
    <div className={styles.container}>
      <label style={{ color: styles.color }}>{title}</label>
      <select
        style={styles}
        value={inputValue}
        onChange={handleOnChange}
        disabled={disabled}
      >
        <option value="" disabled>
          Select an option
        </option>
        {generateOptions()}
      </select>
      {/* <FontAwesomeIcon
        className={styles.dropdownSelectIcon}
        icon={faChevronDown}
      /> */}
      <img
        className={styles.dropdownSelectIcon}
        src="https://frontend-assets.buildbox.com/dropdown.svg"
        alt="dropdown"
      />
      <div className={errorMessageStyle}>{errorMessage}</div>
    </div>
  );
}
